// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "./SpaceX.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "./HasuraTypes.res.mjs";
import * as MutationHook2$LiteracyplanetClientFlags from "./MutationHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["mutation DeleteStudentQuestionResponses($studentActivityAttemptId: uuid!)  {\ncontentVersionConflictWithStudentState: delete_student_question_responses(where: {studentActivityAttemptId: {_eq: $studentActivityAttemptId}})  {\n__typename  \naffected_rows  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.contentVersionConflictWithStudentState;
  return {
          contentVersionConflictWithStudentState: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                affected_rows: value$1.affected_rows
              }) : undefined
        };
}

function serialize(value) {
  var value$1 = value.contentVersionConflictWithStudentState;
  var contentVersionConflictWithStudentState;
  if (value$1 !== undefined) {
    var value$2 = value$1.affected_rows;
    var value$3 = value$1.__typename;
    contentVersionConflictWithStudentState = {
      __typename: value$3,
      affected_rows: value$2
    };
  } else {
    contentVersionConflictWithStudentState = null;
  }
  return {
          contentVersionConflictWithStudentState: contentVersionConflictWithStudentState
        };
}

function serializeVariables(inp) {
  return {
          studentActivityAttemptId: inp.studentActivityAttemptId
        };
}

function makeVariables(studentActivityAttemptId, param) {
  return {
          studentActivityAttemptId: studentActivityAttemptId
        };
}

var Mutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useWithState = include.useWithState;

var Mutation = {
  Mutation_inner: Mutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithState: useWithState
};

var M = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useWithState: useWithState
    });

function use$1() {
  var match = M.useWithWordMonsterError("DeleteStudentQuestionResponses.use");
  var mutation = match[0];
  var run = function (studentActivityAttemptId) {
    mutation({
          studentActivityAttemptId: HasuraTypes$LiteracyplanetClientFlags.encode(studentActivityAttemptId)
        });
  };
  return [
          run,
          match[2],
          match[3]
        ];
}

function useFetch() {
  var mutate = M.useAsync("DeleteStudentQuestionResponses");
  return async function (studentActivityAttemptId) {
    return await mutate({
                studentActivityAttemptId: HasuraTypes$LiteracyplanetClientFlags.encode(studentActivityAttemptId)
              });
  };
}

export {
  Mutation ,
  M ,
  use$1 as use,
  useFetch ,
}
/* query Not a pure module */
